export default {
  translation: {
    欢迎使用react: '欢迎使用react',
    userMessagesUnread: 'Hello <1>{{name}}</1>, you have {{count}} unread message. <5>Go to message</5>',
  },
};
